import React from "react";
import Elephants from "../components/Elephants";

function Home() {
  return (
    <div>
      <Elephants />
    </div>
  );
}

export default Home;
